import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Header from '@components/Details/Header'
import Badge from '@components/Details/Badge'
import PropTypes from 'prop-types'

class ResultsHeader extends Component {
  render () {
    return (
      <Header>
        <div className='info info--noLeft'>
          <h1>Contracts</h1>
        </div>
        <Badge label='Contracts' value={this.props.contractsCount} />
      </Header>
    )
  }

  static propTypes = {
    contractsCount: PropTypes.number
  }
}

export default observer(ResultsHeader)
